import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export interface QuantificationGridHeaderProps {
  name: string;
  unit?: string;
}

const QuantificationGridHeader = (props: QuantificationGridHeaderProps) => {
  return (
    <Box className="MuiDataGrid-columnHeaderTitle quantification-grid-header">
      <>
        <Typography className="quantification-grid-name" component="div" variant="caption">
          {props.name}
        </Typography>
        {props.unit && (
          <Typography component="div" variant="caption">
            ({props.unit})
          </Typography>
        )}
      </>
    </Box>
  );
};

export default QuantificationGridHeader;
